import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, body>({
    query: (body) => ({
      url: `/v4/pitch-owner/stadiums/${body?.stadiumId}/daysoff/${body?.id}`,
      method: 'Delete',
      body,
    }),
  });

export interface body {
  stadiumId: number;
  id: number;
}
